import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { plattPlugins } from '@platt-internal/frontend-defaults';
import { featureFlaggedLoader } from '@platt/frontend-feature-loader';

export default createApp({
  features: [catalogPlugin, plattPlugins, featureFlaggedLoader],
});
